module.exports = __webpack_public_path__ + "static/media/baozhigou.28779d29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/hedged/baozhigou.jpg
// module id = 476
// module chunks = 0